import { render, staticRenderFns } from "./page8.vue?vue&type=template&id=b2d1d4d6&scoped=true"
import script from "./page8.vue?vue&type=script&lang=js"
export * from "./page8.vue?vue&type=script&lang=js"
import style0 from "./page8.vue?vue&type=style&index=0&id=b2d1d4d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d1d4d6",
  null
  
)

export default component.exports